import acknowledgeTemplateTh from '@/i18n/acknowledgeRisk/th'
import termsAndConditionsTemplateTh from '@/i18n/termsAndConditions/th'

export const th = {
  messages: {
    per_total_income: 'ต่อเงินได้ทั้งหมด',
    please_specify: 'โปรดระบุ',
    loading: 'กำลังโหลด',
    close: 'ปิด',
    back: 'กลับ',
    receive: 'ได้รับ',
    for_receive: 'เพื่อรับ',
    copied: 'คัดลอกแล้ว !',
    can_not_copy: `ไม่สามารถคัดลอกได้ กรุณาลองอีกครั้ง`,
    no_result_found: 'ไม่พบข้อมูล',
    img_size_must_less_than: 'ขนาดรูปภาพต้องน้อยกว่า {0} MB',
    uploading_your: 'กำลังอัปโหลด',
    submitting_your_info: 'กำลังอัปโหลดข้อมูลของคุณ',
    click_to_see_doc: 'กดเพื่อดูเอกสาร',
    congratulations: 'ยินดีด้วย',
    you_have_got_kul: `คุณได้รับเหรียญ {0} KUL`,
    thanks_for_connect_social_with_us: 'ขอบคุณที่เชื่อมต่อ {0} กับเรา',
    thanks_for_subscribe: 'ขอบคุณที่สมัครสมาชิกจดหมายข่าวกับเรา',
    thanks_for_registration: 'ขอบคุณที่สมัครสมาชิกกับเรา',
    thanks_for_submited: 'ขอบคุณสำหรับข้อมูลการยืนยันตัวตน',
    google: 'กูเกิล',
    facebook: 'เฟซบุ๊ก',
    not_support: 'ไม่รองรับ',
    wrong_eth_network:
      '<span>กรุณาเปลี่ยนเน็ตเวิร์คไปยัง <b>{0} Ethereum Network</b>.</span>',
    please_fill_info: 'กรุณากรอกข้อมูล',
    hi: 'สวัสดี',
    please_confirm_email_after_regis:
      'กรุณายืนยันอีเมลหลังจากลงทะเบียนเสร็จสิ้น',
    resend_an_email: 'ส่งอีเมลยืนยันอีกครั้ง',
    metamask_connected: 'เชื่อมต่อ Metamask แล้ว !',
    wallet_connect_connected: 'เชื่อมต่อ Wallet Connect แล้ว !',
    login_error: 'ไม่สามารถเข้าสู่ระบบ',
    not_login_metamask:
      'คุณอาจจะยังไม่ได้เข้าสู่ระบบ <b>MetaMask</b>, กรุณาเข้าสู่ระบบแล้วลองใหม่อีกครั้ง.'
  },
  button: {
    login: 'เข้าสู่ระบบ'
  },
  profile: {
    profile: 'ข้อมูลส่วนตัว',
    display_name: 'ชื่อที่แสดง',
    email_address: 'อีเมล',
    connect_with_facebook: 'เชื่อมต่อเฟซบุ๊ก',
    connect_facebook_acc: 'เชื่อมต่อระบบด้วยบัญชีเฟซบุ๊ก',
    connect_with_google: 'เชื่อมต่อกูเกิล',
    connect_google_acc: 'เชื่อมต่อระบบด้วยบัญชีกูเกิล',
    indentification: '', //new
    indentification_detail:
      'ผู้ใช้งานกรอกเอกสารการยืนยันตัวตน และอัปโหลดเอกสารเพิ่มเติม',
    exchange_condition: 'จะสามารถแลกเปลี่ยนได้หลังจากยืนยันตัวตนเสร็จสิ้น',
    suit_test: '', //new
    suit_test_detail: 'แบบสอบถามเพื่อประเมินความเหมาะสมในการลงทุนของลูกค้า',
    knowledge_test: '', // new
    knowledge_test_detail: 'แบบสอบถามเพื่อประเมินความรู้ในการลงทุนของลูกค้า',
    take_a_test: 'ทำแบบประเมิน',
    verification: '', // new
    two_fact: 'การยืนยันแบบสองขั้นตอน',
    two_fact_detail:
      'เพิ่มความปลอดภัยให้กับบัญชีของคุณด้วยการยืนยันแบบสองขั้นตอน'
  },
  login: {
    remember_me: 'ให้ฉันอยู่ในระบบต่อไป',
    login_uppercase: 'เข้าสู่ระบบ',
    register_now: 'สมัครสมาชิก'
  },
  register: {
    register: 'สมัครสมาชิก',
    register_uppercase: 'สมัครสมาชิก',
    login_with: 'เข้าสู่ระบบด้วย {0}',
    or: 'หรือ',
    email: 'อีเมล',
    password: 'รหัสผ่าน',
    terms_of_use: '' //new
  },
  kyc: {
    kyc: '', //new
    kyc_placeholder: '', //new
    kyc_regist_com: ''
  },
  menu: {
    profile: 'ข้อมูลส่วนตัว',
    tradeHistory: 'ประวัติการเทรด',
    kyc: 'ยืนยันตัวตน',
    suit_test: 'แบบประเมินความเสี่ยงด้านการลงทุน',
    knowledge_test: 'แบบทดสอบประเมินความรู้',
    knowledge_test_correct_answer: 'เฉลยคำตอบที่ถูกต้อง',
    logout: 'ออกจากระบบ'
  },
  suit_test: {
    country: 'ประเทศที่ {index}',
    q_1: {
      q: 'ลูกค้าอายุเท่าไหร่',
      a_1: 'ต่ำกว่า 20 ปี',
      a_2: 'ตั้งแต่ 20 ปี แต่ไม่เกิน 30 ปี',
      a_3: 'ตั้งแต่ 30 ปี แต่ไม่เกิน 45 ปี',
      a_4: 'ตั้งแต่ 45 ปี แต่ไม่เกิน 60 ปี',
      a_5: '60 ปีขึ้นไป'
    },
    q_2: {
      q: 'การศึกษา',
      a_1: 'ต่ำกว่าปริญญาตรี',
      a_2: 'ปริญญาตรี',
      a_3: 'สูงกว่าปริญญาตรี'
    },
    q_3: {
      q: 'วัตถุประสงค์ของการสมัครใช้บริการ (สามารถเลือกได้มากกว่า 1 ข้อ)',
      a_1: `เพื่อการออม`,
      a_2: 'เพื่อการลงทุน',
      a_3: 'เพื่อโอนสินทรัพย์ดิจิทัลระหว่างประเทศ',
      a_4: 'เพื่อซื้อโทเคนระดมทุน (ICO)',
      a_5: 'อื่น ๆ'
    },
    q_4: {
      q: 'ระยะเวลาการลงทุน (ระยะเวลาที่คาดว่าจะลงทุนในสินทรัพย์ดิจิทัลแต่ละครั้ง)',
      a_1: `ระยะสั้น ไม่เกิน 1 เดือน`,
      a_2: 'เกินกว่า 1 เดือน แต่ไม่เกิน 6 เดือน',
      a_3: 'เกินกว่า 6 เดือน แต่ไม่เกิน 1 ปี',
      a_4: 'เกินกว่า 1 ปี แต่ไม่เกิน 3 ปี',
      a_5: '3 ปีขึ้นไป'
    },
    q_5: {
      q: 'แหล่งที่มาของเงินได้ (สามารถเลือกได้มากกว่า 1 ข้อ)',
      a_1: `เงินออม`,
      a_2: 'เงินเดือน/ค่าจ้าง',
      a_3: 'มรดก/ของขวัญ',
      a_4: 'ธุรกิจส่วนตัว',
      a_5: 'ตราสาร/กองทุน',
      a_6: 'ผู้ปกครอง',
      a_7: 'อื่น ๆ'
    },
    q_6: {
      q: 'แหล่งที่มารายได้มาจากประเทศใด',
      a_1: `แหล่งที่มารายได้มาจากประเทศเดียว`,
      a_2: 'แหล่งที่มารายได้มาจากประเทศไทยเกินกว่าร้อยละ 80 และต่างประเทศ',
      a_3: 'แหล่งที่มารายได้มาจากประเทศไทยต่ำกว่าร้อยละ 80 และต่างประเทศ',
      a_4: 'แหล่งที่มารายได้มาจากต่างประเทศ 2 ประเทศ',
      a_5: 'แหล่งที่มารายได้มาจากต่างประเทศมากกว่า 2 ประเทศ'
    },
    q_7: {
      q: 'รายได้เฉลี่ยต่อเดือน',
      a_1: `น้อยกว่า 10,000 บาท (น้อยกว่า 300 USD)`,
      a_2: '10,000 - 14,999 บาท (300 USD - 449 USD)',
      a_3: '15,000 - 34,999 บาท (450 USD - 999 USD)',
      a_4: '35,000 - 49,999 บาท (1,000 USD - 1,499 USD)',
      a_5: '50,000 - 99,999 บาท (1,500 USD - 2,999 USD)',
      a_6: '100,000 - 499,999 บาท (3,000 USD - 14,999 USD)',
      a_7: 'มากกว่า 500,000 บาท (มากกว่า 15,000 USD)'
    },
    q_8: {
      q: 'ปริมาณสินทรัพย์ทั้งหมดที่ลูกค้าเป็นเจ้าของ',
      a_1: `น้อยกว่า 500,000 บาท (น้อยกว่า 15,000 USD)`,
      a_2: '500,000 - 1,000,000 บาท (15,000 USD - 29,999 USD)',
      a_3: '1,000,000 - 5,000,000 บาท (30,000 USD - 149,999 USD)',
      a_4: '5,000,000 - 10,000,000 บาท (150,000 USD - 299,999 USD)',
      a_5: '10,000,000 - 100,000,000 บาท (300,000 USD - 2,999,999 USD)',
      a_6: 'มากกว่า 100,000,000 บาท (มากกว่า 3,000,000 USD)'
    },
    q_9: {
      q: 'สัดส่วนการลงทุนระหว่างสินทรัพย์ดิจิทัลกับสินทรัพย์ทั้งหมด',
      a_1: `น้อยกว่าร้อยละ 10`,
      a_2: 'ตั้งแต่ร้อยละ 10 แต่ไม่เกินร้อยละ 30',
      a_3: 'ตั้งแต่ร้อยละ 30 แต่ไม่เกินร้อยละ 50',
      a_4: 'ตั้งแต่ร้อยละ 50 แต่ไม่เกินร้อยละ 80',
      a_5: 'ตั้งแต่ร้อยละ 80 ขึ้นไป'
    },
    q_10: {
      q: 'ท่านมีประสบการณ์การลงทุนในหลักทรัพย์หรือไม่ (หลักทรัพย์ หมายถึง หน่วยลงทุน หุ้น หุ้นกู้ พันธบัตรรัฐบาล ตราสารอนุพันธ์ สินทรัพย์ดิจิทัล หรือเครื่องมือทางการเงินอื่นทำนองเดียวกัน)',
      a_1: `ไม่มีประสบการณ์เลย`,
      a_2: 'มีประสบการณ์ไม่เกิน 1 ปี',
      a_3: 'มีประสบการณ์ตั้งแต่ 1 ปี แต่ไม่เกิน 3 ปี',
      a_4: 'มีประสบการณ์ตั้งแต่ 3 ปี แต่ไม่เกิน 10 ปี',
      a_5: 'มีประสบการณ์ตั้งแต่ 10 ปีขึ้นไป'
    },
    q_11: {
      q: 'ระดับความเสี่ยงของการลงทุนที่ยอมรับได้',
      a_1: `รับความเสี่ยงไม่ได้ ชอบการลงทุนที่ปลอดภัย สร้างรายได้ประจำ แม้ว่าผลตอบแทนต่ำ`,
      a_2: 'รับความเสี่ยงได้พอควร เพื่อเพิ่มโอกาสที่จะได้รับผลตอบแทนที่สูงขึ้นในระยะยาว',
      a_3: 'รับความเสี่ยงได้สูง เพื่อเพิ่มโอกาสที่จะได้รับผลตอบแทนที่สูงกว่าในระยะยาว',
      a_4: 'รับความเสี่ยงได้สูงมาก เพื่อสร้างโอกาสที่จะได้รับผลตอบแทนสูงสุดจากการลงทุน'
    },
    q_12: {
      q: 'ท่านคิดว่าท่านยอมรับผลขาดทุนจากการลงทุนในครั้งหนึ่งได้มากน้อยเพียงใด',
      a_1: `ไม่สามารถรับผลขาดทุนได้เลย`,
      a_2: 'ต่ำกว่าร้อยละ 10 ของเงินลงทุน',
      a_3: 'ประมาณร้อยละ 10 - 30 ของเงินลงทุน',
      a_4: 'ประมาณร้อยละ 30 - 70 ของเงินลงทุน',
      a_5: 'รับผลขาดทุนได้ทั้งหมด'
    },
    q_13: {
      q: 'เคยถูกศาลพิพากษาให้มีความผิดในฐานความผิดที่เกี่ยวข้องกับทรัพย์สิน หรือถูกศาลมีคำสั่งให้ทรัพย์สินตกเป็นของแผ่นดิน หรือไม่',
      a_1: 'ไม่เคย',
      a_2: 'เคย'
    },
    q_14: {
      q: 'เคยถูกเรียกให้แสดงบัญชีรายการทรัพย์สินต่อหน่วยงานภาครัฐ เช่น สำนักงานคณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ สำนักงานป้องกันและปราบปรามการฟอกเงิน หรือไม่',
      a_1: 'ไม่เคย',
      a_2: 'เคย'
    },
    q_15: {
      q: 'ท่าน/บิดา มารดา/คู่สมรส/บุตร/ผู้ร่วมงานใกล้ชิด ดำรงตำแหน่งหรือเคยดำรงตำแหน่งทางการเมืองในประเทศใดๆหรือไม่',
      a_1: 'ไม่ใช่',
      a_2: 'ใช่'
    },
    alert_message: '*โปรดอ่านข้อความหรือเลื่อนดูข้อความจนสุดบรรทัด',
    accept_acknowledge_risk:
      'ข้าพเจ้าได้อ่าน และตกลงยินยอมตามรายละเอียดข้อตกลงและความยินยอมข้างต้น'
  },
  knowledge_test: {
    cryptocurrency: {
      q_1: {
        q: 'คริปโทเคอร์เรนซี (Cryptocurrency) คืออะไร',
        a_1: 'หน่วยข้อมูลอิเล็กทรอนิกส์ที่สร้างขึ้นเพื่อใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้า บริการ สินทรัพย์ดิจิทัลอื่น หรือสิทธิอื่นใด โดยมีการเข้ารหัสบนระบบที่เรียกว่า “บล็อกเชน (Blockchain)”',
        a_2: 'หุ้นประเภทหนึ่งที่ออกโดยรัฐบาล',
        a_3: 'กองทุนที่ผูกกับราคาทองคำ'
      },
      q_2: {
        q: 'ข้อใดเป็นลักษณะของ Stablecoin ',
        a_1: 'คริปโทเคอร์เรนซีที่ผูกมูลค่าไว้เท่ากับสินทรัพย์อื่น',
        a_2: 'มีความผันผวนสูงมากขึ้นลงได้หลายเท่าในเวลาอันรวดเร็ว',
        a_3: 'มีมูลค่าลดลงรุนแรงตามเวลาที่กำหนด'
      },
      q_3: {
        q: 'ข้อใดเป็นความแตกต่างระหว่างคริปโทเคอร์เรนซี และทองคำ',
        a_1: 'คริปโทเคอร์เรนซี สามารถซื้อขาย แลกเปลี่ยน และสะสมเพื่อเก็งกำไรได้',
        a_2: 'คริปโทเคอร์เรนซี มีการเข้ารหัส และเก็บรักษาข้อมูลด้วยเทคโนโลยีบล็อกเชน',
        a_3: 'ทองคำมีราคาในการซื้อขายที่แปรผันตามสภาวะตลาด',
        a_4: 'ถูกทุกข้อ'
      },
      q_4: {
        q: 'ข้อใดคือความแตกต่างระหว่างคริปโตเคอร์เรนซีและสินทรัพย์แบบดั้งเดิม',
        a_1: 'คริปโตเคอร์เรนซีใช้เทคโนโลยีบล็อกเชน',
        a_2: 'สามารถซื้อขายแลกเปลี่ยนได้ผ่านตัวกลางได้ เช่น Exchange, Broker หรือ Dealer',
        a_3: 'สามารถใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้าและบริการได้ตามกฎหมายไทย',
        a_4: 'ถูกต้องทุกข้อ'
      },
      q_5: {
        q: 'ข้อใดถูกต้องเกี่ยวกับลักษณะของคริปโทเคอร์เรนซีและโทเคนดิจิทัล',
        a_1: 'คริปโทเคอร์เรนซีและโทเคนดิจิทัลมีลักษณะเป็นหน่วยข้อมูลอิเล็กทรอนิกส์หรือไม่ก็ได้',
        a_2: 'คริปโทเคอร์เรนซีถูกสร้างขึ้นเพื่อใช้สำหรับเป็นสื่อกลางในการซื้อขายแลกเปลี่ยนสินค้าหรือบริการ ในขณะที่โทเคนดิจิทัลถูกสร้างขึ้นเพื่อกำหนดสิทธิในการได้มาซึ่งสินค้าหรือบริการหรือสิทธิอื่นใดให้แก่ผู้ถือ',
        a_3: 'หลักทรัพย์ (เช่น หุ้น หุ้นกู้ เป็นต้น) ที่สร้างขึ้นบนระบบบล็อกเชน ไม่ถือว่าเป็นหลักทรัพย์ แต่อาจเป็นสินทรัพย์ดิจิทัลประเภทคริปโทเคอร์เรนซีหรือโทเคนดิจิทัลได้',
        a_4: 'Stable coin ไม่ถือเป็นคริปโทเคอร์เรนซีหรือโทเคนดิจิทัล '
      },
      q_6: {
        q: 'ข้อใดไม่ถูกต้อง',
        a_1: 'คริปโทเคอร์เรนซี กับ โทเคนดิจิทัล มีความหมายเหมือนกัน',
        a_2: 'โทเคนดิจิทัล คือ หน่วยข้อมูลอิเล็กทรอนิกส์ที่ถูกสร้างขึ้นบนระบบโดยมีวัตถุประสงค์เพื่อกำหนดสิทธิในการเข้าร่วมโครงการหรือกิจการใด หรือกำหนดสิทธิในการได้มาซึ่งสินค้าหรือบริการที่เจาะจง',
        a_3: 'คริปโทเคอร์เรนซี คือ หน่วยข้อมูลอิเล็กทรอนิกส์ที่ถูกสร้างโดยมีความประสงค์ที่จะใช้เป็นสื่อกลางในการแลกเปลี่ยนซึ่งสินค้าหรือบริการ สิทธิอื่นใด หรือแลกเปลี่ยนระหว่างสินทรัพย์ดิจิทัล',
        a_4: 'ไม่มีข้อใดถูก'
      },
      q_7: {
        q: 'ข้อใดไม่ใช่ความหมายของ Stablecoin',
        a_1: 'คริปโทเคอร์เรนซีที่อ้างอิงมูลค่าสินทรัพย์สินทรัพย์โภคภัณฑ์ เช่น ทอง หรือ น้ำมัน',
        a_2: 'คริปโทเคอร์เรนซีที่นิยมซื้อไว้เพื่อเก็งกำไร',
        a_3: 'คริปโทเคอร์เรนซีที่มีความผันผวนน้อยกว่าคริปโทเคอร์เรนซีประเภทอื่น',
        a_4: 'คริปโทเคอร์เรนซีที่มีการคงมูลค่าไว้กับสกุลเงินต่างๆ'
      },
      q_8: {
        q: 'ข้อใดคือลักษณะสำคัญของคริปโทเคอร์เรนซี',
        a_1: 'หน่วยข้อมูลอิเล็กทรอนิกส์ที่ถูกสร้างขึ้นบนระบบหรือเครือข่ายอิเล็กทรอนิกส์',
        a_2: 'มีวัตถุประสงค์เพื่อใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้า บริการ สินทรัพย์ดิจิทัลอื่นหรือสิทธิอื่นใด',
        a_3: 'ยังไม่มีการรับรองว่าสามารถใช้ชำระหนี้ได้ตามกฎหมาย',
        a_4: 'ถูกทุกข้อ'
      },
      q_9: {
        q: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับ Stablecoin',
        a_1: 'จัดเป็นหนึ่งในประเภทของคริปโทเคอร์เรนซีภายใต้กฎหมายไทย',
        a_2: 'มีกลไกการคงมูลค่าไว้กับเงินตราหรือสินทรัพย์อื่น',
        a_3: 'ราคาของสินทรัพย์ดิจิทัลประเภทนี้จะไม่ผันผวนตามอุปสงค์หรือ ความต้องการของตลาดต่างจากคริปโทเคอร์เรนซีประเภทอื่น',
        a_4: 'Bitcoin และ Ethereum เป็น Stable coin อย่างหนึ่ง '
      },
      q_10: {
        q: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับความเเตกต่างระหว่าง คริปโทเคอร์เรนซีกับโทเคนดิจิทัลและสินทรัพย์แบบดั้งเดิม',
        a_1: 'ธุรกรรมสินทรัพย์ดิจิทัลทำได้โดยไม่ต้องผ่านหน่วยงานกลาง เพราะสามารถดำเนินการและตรวจสอบโดยโปรโตคอลยืนยันร่วมกัน ทั่วทั้งเครือข่ายแทนอยู่เเล้ว',
        a_2: 'กำหนดเวลาในการซื้อขายสินทรัพย์ดิจิทัลมีตลอดเวลา 24 ชั่วโมงทั่วโลก และมีการส่งมอบแบบเรียลไทม์',
        a_3: 'ผลตอบแทนของสินทรัพย์ดิจิทัลส่วนใหญ่ไม่มีการจ่ายเงินปันผล เหมือนอย่างสินทรัพย์ดั้งเดิม',
        a_4: 'ราคาของสินทรัพย์ดิจิทัลที่จะไม่เปลี่ยนแปลงไปตามอุปสงค์ของตลาด เหมือนอย่างสินทรัพย์ดั้งเดิม'
      },
      q_11: {
        q: 'ข้อใดไม่ใช่ลักษณะของคริปโทเคอร์เรนซี (Cryptocurrency)',
        a_1: 'เป็นเงินที่ทุกธนาคารกลางใดในโลกรับรองว่าสามารถใช้ชำระหนี้ได้ตามกฎหมาย',
        a_2: 'โดยส่วนใหญ่ ถูกสร้างขึ้นโดยใช้เทคโนโลยี Blockchain สนับสนุนการแลกเปลี่ยนระหว่างผู้ใช้งาน',
        a_3: 'ไม่สามารถใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้าและบริการได้ตามกฎหมายไทย',
        a_4: 'สามารถซื้อขายแลกเปลี่ยนได้ผ่านตัวกลางได้ เช่น Exchange, Broker หรือ Dealer'
      },
      q_12: {
        q: 'ข้อใดคือความหมายของ Stable Coin',
        a_1: 'มีระบบป้องกันปิดบังตัวตนของผู้ใช้งานไม่ให้รั่วไหลออกไป',
        a_2: 'กำหนดสิทธิในการเข้าร่วมลงทุนในโครงการ',
        a_3: 'มูลค่าค่อนข้างคงที่ ราคาเคลื่อนไหวตามมูลค่าของสินทรัพย์ที่ค้ำไว้ ',
        a_4: 'เหรียญที่สร้างขึ้นเพื่อความสนุก เหรียญล้อเลียน หรือ สร้างขึ้นตามกระแส'
      },
      q_13: {
        q: 'ข้อใดกล่าวได้ถูกต้อง',
        a_1: 'Fiat Currency เช่น US Dollar สามารถใช้ชำระหนี้ได้ตามกฎหมาย',
        a_2: 'โทเคนดิจิทัลไม่สามารถใช้เพื่อแลกซื้อสินค้าในวงจำกัดได้',
        a_3: 'โทเคนดิจิทัลไม่สามารถใช้เพื่อวัตถุประสงค์ในการระดมทุนได้',
        a_4: 'คริปโทเคอร์เรนซีสามารถนำไปชำระค่าสินค้าและบริการในรูปแบบธนบัตรหรือเหรียญได้'
      },
      q_14: {
        q: 'ข้อใดต่อไปนี้กล่าวถูกต้องเกี่ยวกับลักษณะของคริปโทเคอร์เรนซี',
        a_1: 'หน่วยอิเล็กทรอนิกส์ที่สร้างขึ้นบนเครือข่ายอิเล็กทรอนิกส์เพื่อใช้เป็นสื่อกลางในการแลกเปลี่ยนสินค้าหรือบริการ',
        a_2: 'หน่วยอิเล็กทรอนิกส์ที่สร้างขึ้นบนเครือข่ายอิเล็กทรอนิกส์เพื่อกำหนดสิทธิในการได้มาซึ่งสินค้าหรือบริการ',
        a_3: 'หน่วยอิเล็กทรอนิกส์ที่สร้างขึ้นบนเครือข่ายอิเล็กทรอนิกส์เพื่อแสดงสิทธิ์ความเป็นเจ้าของในสินค้าหรือบริการ',
        a_4: 'หน่วยอิเล็กทรอนิกส์ที่สร้างขึ้นบนเครือข่ายอิเล็กทรอนิกส์เพื่อยืนยันตัวตน'
      },
      q_15: {
        q: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับ “คริปโทเคอเรนซี”',
        a_1: 'คริปโทเคอเรนซี่ จัดเป็นสินทรัพย์ที่มีความผันผวนสูง เมื่อเทียบกับการลงทุนประเภทอื่นๆ',
        a_2: '“บิทคอยน์” คือคริปโทเคอเรนซี่',
        a_3: 'คริปโทเคอเรนซี่ มีการใช้เทคโนโลยี Blockchain เป็นเบื้องหลังในการดำเนินการ',
        a_4: 'ปัจจุบันคริปโทเคอเรนซี่ สามารถใช้ชำระหนี้ตามกฏหมายของราชอาณาจักรไทยได้'
      },
      q_16: {
        q: 'คริปโทเคอร์เรนซีมีสถานะทางกฎหมายในประเทศไทยอย่างไร',
        a_1: 'เป็นสิ่งผิดกฎหมาย',
        a_2: 'สถานะเป็นสินทรัพย์ที่มีลักษณะเป็นข้อมูลอิเล็กทรอนิกส์',
        a_3: 'เป็นสกุลเงินประเภทหนึ่ง',
        a_4: 'เป็นข้อมูลทางอิเล็คทรอนิกส์'
      },
      q_17: {
        q: 'ข้อใดไม่ถูกต้อง',
        a_1: 'คริปโทเคอร์เรนซี กับ โทเคน ความหมายเหมือนกัน',
        a_2: 'โทเคน (Token) คือ หน่วยข้อมูลอิเล็กทรอนิกส์ที่ถูกสร้างขึ้น ตามจุดประสงค์ของผู้ออกโทเคน ซึ่งมีฟังก์ชันการใช้งานที่แตกต่างกันออกไป',
        a_3: 'คริปโทเคอร์เรนซี (Cryptocurrency) คือ สินทรัพย์ดิจิทัลประเภทหนึ่งที่มีการรักษาความปลอดภัยด้วยการเข้ารหัส ถูกออกแบบมาเพื่อใช้เป็นสื่อกลางในการแลกเปลี่ยนเช่นเดียวกับสกุลเงินทั่วไป',
        a_4: 'ไม่มีข้อใดถูก'
      },
      q_18: {
        q: 'ข้อใดไม่ใช่ stable coin',
        a_1: 'USDT',
        a_2: 'DAI',
        a_3: 'ETH',
        a_4: 'TUSD'
      }
    },
    blockchain: {
      q_1: {
        q: 'ข้อใดเป็นปัจจัยที่ทำให้เทคโนโลยีบล็อกเชน (Blockchain) มีความปลอดภัย',
        a_1: 'มีความโปร่งใส ง่ายต่อการตรวจสอบ',
        a_2: 'มีการเข้ารหัสข้อมูล',
        a_3: 'แก้ไขข้อมูลได้ยาก',
        a_4: 'ถูกทุกข้อ'
      },
      q_2: {
        q: 'ข้อใดถูกต้องเกี่ยวกับบล็อกเชน (Blockchain)',
        a_1: 'บล็อกเชนไม่เกี่ยวข้องกับคริปโทเคอร์เรนซี',
        a_2: 'บล็อกเชนเก็บข้อมูลแบบรวมศูนย์ (Centralized)',
        a_3: 'บล็อกเชนเป็นเทคโนโลยีที่เก็บข้อมูลธุรกรรมของคริปโทเคอร์เรนซี'
      },
      q_3: {
        q: 'Proof of Stake Consensus คืออะไร',
        a_1: 'กลไกที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องของธุรกรรมใหม่ด้วยการให้ "ผู้ตรวจสอบ (validator)" ที่ทำการถือสินทรัพย์ดิจิทัลไว้ตามจำนวนที่กำหนดไว้ และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_2: 'กลไลที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องของธุรกรรมด้วยการให้ "ผู้ตรวจสอบ หรือผู้ขุด (miner)" ทำการแก้ไขโจทย์ที่มีการเข้ารหัส (cryptographic puzzle) และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_3: 'กลไกที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องธุรกรรมโดยผู้ตรวจสอบที่ได้มีการทำการสุ่มระหว่างกันเอง และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_4: 'ไม่มีข้อใดถูกต้อง'
      },
      q_4: {
        q: 'Proof of Work Consensus คืออะไร',
        a_1: 'กลไกที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องของธุรกรรมใหม่ด้วยการให้ "ผู้ตรวจสอบ (validator)" ที่ทำการถือสินทรัพย์ดิจิทัลไว้ตามจำนวนที่กำหนดไว้ และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_2: 'กลไลที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องของธุรกรรมด้วยการให้ "ผู้ตรวจสอบ หรือผู้ขุด (miner)" ทำการแก้ไขโจทย์ที่มีการเข้ารหัส (cryptographic puzzle) และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_3: 'กลไกที่มีการตกลงร่วมกันให้มีการตรวจสอบความถูกต้องธุรกรรมโดยผู้ตรวจสอบที่ได้มีการทำการสุ่มระหว่างกันเอง และเมื่อตรวจสอบธุรกรรมแล้วผู้ตรวจสอบก็จะได้รับรางวัล',
        a_4: 'ไม่มีข้อใดถูกต้อง'
      },
      q_5: {
        q: 'ข้อใดต่อไปนี้คือสิ่งที่อาจจะเกิดขึ้นในการถอนเหรียญ เมื่อกรอก Address ผู้รับผิดพลาด',
        a_1: 'เหรียญจะถูกคืนกลับสู่บัญชีล่าสุดเนื่องจากเลขหมาย Address ของผู้รับไม่ถูกต้อง',
        a_2: 'เหรียญจะถูกโอนไปยังปลายทางแต่ไม่ใช่บัญชีที่ถูกต้อง และอาจไม่สามารถกู้คืนกลับมาได้',
        a_3: 'ไม่มีอะไรเกิดขึ้นเหรียญถูกโอนไปยังปลายทางได้อย่างถูกต้อง',
        a_4: 'ไม่มีข้อใดถูก'
      },
      q_6: {
        q: 'เทคโนโลยีบล็อกเชน (Blockchain Technology) คืออะไร',
        a_1: 'เทคโนโลยีบล็อกเชนมีลักษณะการเก็บข้อมูลในแต่ละช่วงเวลาต่อกันเหมือนห่วงโซ่ที่เชื่อมต่อกันไปเรื่อยๆ โดยจะมีการสำเนาข้อมูลทั้งหมดและกระจายให้กับผู้ที่ใช้งานระบบทุกคน',
        a_2: 'เทคโนโลยีที่ไม่ต้องอาศัยคนกลาง แต่ให้ผู้ที่มีส่วนร่วมในเครือข่ายบล็อกเชนทุกคนตรวจสอบข้อมูลระหว่างกัน ทำให้การแก้ไขข้อมูลบนเทคโนโลยีบล็อกเชนเป็นไปได้ยาก หรือแทบจะเป็นไปไม่ได้',
        a_3: 'เทคโนโลยีที่สามารถพัฒนาเป็นสัญญาอัจฉริยะ (Smart Contract) เพื่อใช้ในการประมวลผลเงื่อนไขต่างๆ ในรูปแบบ If-Then เพื่อให้ธุรกรรมเสร็จสมบูรณ์ได้',
        a_4: 'ถูกทุกข้อ'
      },
      q_7: {
        q: 'ข้อใดไม่ใช่ความเสี่ยงของเทคโนโลยี Blockchain',
        a_1: 'การเชื่อมต่อระบบโครงสร้างพื้นฐานเดิมกับเครือข่าย Blockchain ที่ไม่มั่นคงเพียงพอ จะกระทบต่อการประมวลผลข้อมูลโดยรวมของระบบได้',
        a_2: 'การเปลี่ยนแปลงของข้อมูลทำให้เกิดความไม่โปร่งใสของระบบ',
        a_3: 'การเปลี่ยนแปลงของเทคโนโลยีจนเพิ่มภัยคุกคามทางไซเบอร์ได้',
        a_4: 'การเปลี่ยนแปลงทางด้านการกำกับดูแลกฎหมาย'
      },
      q_8: {
        q: 'ข้อใดคือความหมายของโหนด (Node)',
        a_1: 'บล็อกเชน (Blockchain)',
        a_2: 'คริปโทเคอร์เรนซีประเภทหนึ่ง',
        a_3: 'คอมพิวเตอร์ที่เชื่อมต่อเข้ากับเครือข่ายบล็อกเชน',
        a_4: 'ประเภทของกระเป๋าสินทรัพย์ดิจิทัล'
      },
      q_9: {
        q: 'ข้อใดไม่ใช่ลักษณะสำคัญของ Blockchain',
        a_1: 'ความไร้พรหมแดน',
        a_2: 'การปรับปรุงแก้ไขข้อมูลตามความต้องการ ของผู้ใช้งาน',
        a_3: 'ความสามารถในการเป็นเจ้าของ',
        a_4: 'การไม่สามารถเปลี่ยนแปลงแก้ไขได้'
      },
      q_10: {
        q: 'คุณลักษณะพื้นฐานของเทคโนโลยีบล็อกเชนใด ไม่เกี่ยวข้องกับกระบวนการสร้างและการซื้อขาย คริปโทเคอร์เรนซี',
        a_1: 'ความถูกต้องเที่ยงตรงของข้อมูล (Data Integrity)',
        a_2: 'ความโปร่งใสในการเข้าถึงข้อมูล (Data Transparency)',
        a_3: 'ความสามารถในการการติดตามธุรกรรม(Transaction tracsability)',
        a_4: 'ความสามารถในการระบุตัวตน (Ability of identification)'
      },
      q_11: {
        q: 'ข้อใดไม่ใช่ลักษณะหลักของเทคโนโลยีบล็อกเชน',
        a_1: 'สามารถทำธุรกรรมกันแบบ Peer-to-Peer ได้',
        a_2: 'มีการประมวลผลและจัดเก็บข้อมูลแบบกระจายศูนย์ได้',
        a_3: 'ธุรกรรมที่บันทึกบนบล็อกเชนสามารถแก้ไขได้',
        a_4: 'ฐานข้อมูลบล็อกเชนจะจัดเก็บข้อมูลในบล็อกที่เชื่อมโยงกันเป็นลูกโซ่'
      },
      q_12: {
        q: 'ข้อใดต่อไปนี้คือลักษณะของ Blockchain',
        a_1: 'เทคโนโลยีการประมวลผลและจัดเก็บข้อมูลแบบกระจายศูนย์',
        a_2: 'ข้อมูลที่ถูกบันทึกในระบบ Blockchain นั้นจะสามารถทำการแก้ไขเปลี่ยนแปลงได้ยาก',
        a_3: 'ข้อมูลมีความโปร่งใสน่าเชื่อถือ และสามารถตรวจสอบได้',
        a_4: 'ถูกทุกข้อ'
      },
      q_13: {
        q: 'ข้อใดไม่ใช่ลักษณะการเก็บข้อมูลของบล็อกเชน',
        a_1: 'การออกแบบโครงสร้างเป็น block',
        a_2: 'การกระจายสถานที่จัดเก็บข้อมูลหลายแห่ง',
        a_3: 'การเก็บข้อมูลแบบรวมศูนย์กลาง'
      },
      q_14: {
        q: 'เทคโนโลยีบล็อคเชนมีความปลอดภัยเนื่องจากมีความสม่ำเสมอจาก 3 ปัจจัยพื้นฐาน คือ การกระจายอำนาจ การเข้ารหัส และฉันทามติ ข้อความนี้เป็นจริงหรือเท็จ?',
        a_1: 'จริง',
        a_2: 'เท็จ'
      },
      q_15: {
        q: 'นักลงทุนต้องระมัดระวังและไม่ตกเป็นเหยื่อการโจมตีทางไซเบอร์ การปกป้องและรักษาความปลอดภัยของคีย์ส่วนตัวเป็นสิ่งสำคัญมาก ใครก็ตามที่มี Private key ของคุณสามารถเข้าถึงเงินทุนของคุณได้ คุณควรทำอย่างไรกับ Private key ของคุณ',
        a_1: 'สามารถเปิดเผย Private key ให้ทุกคนได้เห็น',
        a_2: 'สามารถแบ่งบัน Private key ให้กับเพื่อน',
        a_3: 'เก็บรักษา Private key เป็นความลับ',
        a_4: 'ควรทำสำเนาดิจิทัลของ Private key และจัดเก็บไว้ทางออนไลน์'
      },
      q_16: {
        q: 'จุดเด่นของ Blockchain คืออะไรบ้าง',
        a_1: 'เพิ่มความน่าเชื่อของการจัดเก็บข้อมูล',
        a_2: 'ไม่สามารถเปลี่ยนแปลงและแก้ไขข้อมูลได้',
        a_3: 'ไม่ใช้ตัวกลางในการจัดเก็บข้อมูลและการตรวจสอบ',
        a_4: 'ถูกทุกข้อ'
      },
      q_17: {
        q: 'ข้อใด คือ Blockchain splits?',
        a_1: 'A split',
        a_2: 'A division',
        a_3: 'A sidechain',
        a_4: 'A fork'
      },
      q_18: {
        q: 'อะไร คือ Public Blockchain?',
        a_1: 'เป็น digital ledger ที่ข้อมูลถูกเก็บไว้ในเครือข่ายของคอมพิวเตอร์แต่ละเครื่องอย่างอิสระ',
        a_2: 'เป็น digital ledger ที่ถูกสร้างและจัดการโดยบริษัทแต่เผยแพร่สู่สาธารณะได้',
        a_3: 'เป็นแพลตฟอร์มที่ได้รับการอำนวยความสะดวกจากภาครัฐในการแลกเปลี่ยนเงินตรา',
        a_4: 'เป็นคอมพิวเตอร์ประเภทหนึ่งที่ถูกสร้างขึ้นเพื่อขุดเหรียญบิทคอยน์'
      },
      q_19: {
        q: 'ข้อใดคือคุณสมบัติของ Blockchain What is/are properties of Blockchain?',
        a_1: 'การกระจายศูนย์ (decentralized)',
        a_2: 'การไม่สามารถเปลี่ยนแปลงแก้ไขได้ (immutable)',
        a_3: 'ฉันทามติ (consensus)',
        a_4: 'ถูกทุกข้อ (All of the above)'
      },
      q_20: {
        q: 'ข้อใดถูกต้องเกี่ยวกับ Smart contract',
        a_1: 'เทคโนโลยี NFT ไม่จำเป็นจะต้องอาศัยการทำงานของ Smart contract',
        a_2: 'โปรแกรมที่จัดเก็บไว้ในระบบบล็อกเชนที่ทำงานโดยอัตโนมัติเมื่อตรงตามเงื่อนไขที่กำหนดไว้ล่วงหน้า ซึ่งจะเรียกใช้การตรวจสอบเงื่อนไขและตรรกะ เพื่อให้ธุรกรรมเสร็จสมบูรณ์ได้อย่างมั่นใจ',
        a_3: 'Smart contract สามารถแก้ไขธุรกรรมในอดีตได้',
        a_4: 'ถูกทุกข้อ'
      }
    },
    cryptocurrency_wallet: {
      q_1: {
        q: 'จะเกิดอะไรขึ้นเมื่อคุณส่งสินทรัพย์ดิจิตอลไปที่ wallet address ผิด?',
        a_1: 'สินทรัพย์ดิจิทัลจะคืนกลับมาที่กระเป๋าดิจิทัลของเราเอง',
        a_2: 'สินทรัพย์ดิจิทัลนั้นจะหายไปอย่างถาวร'
      },
      q_2: {
        q: 'ข้อใดต่อไปนี้คือสิ่งที่อาจจะเกิดขึ้นในการถอนเหรียญ เมื่อกรอก Address ผู้รับผิดพลาด',
        a_1: 'เหรียญจะถูกคืนกลับสู่บัญชีล่าสุดเนื่องจากเลขหมาย Address ของผู้รับไม่ถูกต้อง',
        a_2: 'เหรียญจะถูกโอนไปยังปลายทางแต่ไม่ใช่บัญชีที่ถูกต้อง',
        a_3: 'ไม่มีอะไรเกิดขึ้นเหรียญถูกโอนไปยังปลายทางได้อย่างถูกต้อง',
        a_4: 'ข้อ A และ B ถูกต้อง'
      },
      q_3: {
        q: 'ข้อใดคือความเสี่ยงที่อาจเกิดขึ้นได้จากการใช้บริการ “คริปโทเคอเรนซี” ผ่านแพลทฟอร์มการแลกเปลี่ยน (Cryptocurrency Exchange)',
        a_1: 'ทางผู้ให้บริการ (Cryptocurrency Exchange) จะเป็นผู้เก็บ Private Key ไว้',
        a_2: 'ระบบการทำงานของแพลทฟอร์มเกิดการผิดพลาดทำให้ไม่สามารถตั้งคำสั่งซื้อ-ขายได้',
        a_3: 'คริปโทเคอเรนซี่ในบัญชีสูญหายอันเนื่องจากผู้ให้บริการ (Cryptocurrency Exchange) ถูกโจมตีจากกลุ่มผู้ไม่หวังดี',
        a_4: 'ถูกทุกข้อ'
      },
      q_4: {
        q: 'ข้อใดถูกต้องเกี่ยวกับกระเป๋าสินทรัพย์ดิจิทัล (Digital Asset Wallet)',
        a_1: 'ใช้ในการเก็บสินทรัพย์ดิจิทัลก่อนนำไปใช้งานในรูปแบบต่าง ๆ',
        a_2: 'ใช้ในการคำนวณราคาสินทรัพย์ดิจิทัล',
        a_3: 'ไม่ควรใช้ เพราะความปลอดภัยต่ำ'
      },
      q_5: {
        q: 'ข้อใดที่ทำให้คุณโอนคริปโทเคอร์เรนซีไปยังผู้รับปลายทางได้สำเร็จ',
        a_1: 'ตรวจสอบที่อยู่กระเป๋าสินทรัพย์ดิจิทัลของแพลตฟอร์มปลายทาง ทุกครั้ง',
        a_2: 'ศึกษาทำความเข้าใจวิธีการโอน หรือสอบถามเจ้าหน้าที่เพื่อขอคำแนะนำ',
        a_3: 'ถูกทุกข้อ'
      },
      q_6: {
        q: 'นักลงทุนสามารถเก็บคริปโทเคอร์เรนซีและโทเคนดิจิทัลไว้ที่ใด',
        a_1: 'บัญชีธนาคาร (Bank Account)',
        a_2: 'กระเป๋าสินทรัพย์ดิจิทัลที่เชื่อมต่อกับเครือข่ายตลอดเวลา (Hot Wallet)',
        a_3: 'กระเป๋าสินทรัพย์ดิจิทัลที่เชื่อมต่อกับเครือข่ายเมื่อทำธุรกรรมเท่านั้น (Cold Wallet)',
        a_4: 'ถูกทั้ง ข.และ ค.'
      },
      q_7: {
        q: 'ข้อใดไม่ถูกต้องเกี่ยวกับ Hot Wallet และ Cold Wallet',
        a_1: 'ผู้ประกอบธุรกิจสินทรัพย์ดิจิทัลในประเทศไทยจะต้องจัดเก็บสินทรัพย์ดิจิทัลของลูกค้าส่วนใหญ่ไว้ใน Cold wallet หรือนำไปฝากไว้กับ Digital Asset Custody',
        a_2: 'การใช้งาน Cold Wallet มีความปลอดภัยจากการถูกโจรกรรมทางไซเบอร์มากกว่าการใช้งาน Hot Wallet',
        a_3: 'หาก private key ของ Hot Wallet และ Cold Wallet ของผู้ลงทุน ถูกเข้าถึงหรือถูกเปิดเผยให้กับบุคคลที่ไม่มีส่วนเกี่ยวข้อง ควรรีบย้ายสินทรัพย์ดิจิทัลออกจาก Hot Wallet และ Cold Wallet ไปเก็บไว้ที่อื่นทันที',
        a_4: 'ผู้ลงทุนควรจัดเก็บ private key ไว้กับผู้ให้บริการ cloud '
      },
      q_8: {
        q: 'ข้อใดคือวิธีการเก็บรักษากระเป๋าสินทรัพย์ดิจิทัลให้ปลอดภัย',
        a_1: 'เก็บสินทรัพย์ดิจิทัลที่ใช้จ่ายไว้ในกระเป๋าออนไลน์ (Hot Wallet) และเก็บสินทรัพย์ดิจิทัลที่เหลือไว้ในกระเป๋าออฟไลน์ (Cold Wallet)',
        a_2: 'มีกระเป๋าเงินสำรอง กรณีกระเป๋าเงินเสียหายหรือถูกขโมย',
        a_3: 'งดเชื่อมต่อ WiFi สาธารณะ',
        a_4: 'ถูกทุกข้อ'
      },
      q_9: {
        q: 'ข้อใดคือข้อดีของการฝากสินทรัพย์ดิจิทัลของลูกค้า ไว้ในกระเป๋าสินทรัพย์ดิจิทัลของผู้ประกอบธุรกิจ (custodial wallet)',
        a_1: 'ผู้ให้บริการก็จะมีระบบการจัดเก็บให้ จึงไม่ต้องกังวลว่าจะทำ private key สูญหาย',
        a_2: 'ลูกค้าทำธุรกรรมได้สะดวกมากขึ้น',
        a_3: 'ถูกทุกข้อ'
      },
      q_10: {
        q: 'ข้อใดกล่าวถูกต้องเกี่ยวกับประเภทและการใช้งานของสินทรัพย์ดิจิทัล',
        a_1: 'Hardware wallet เป็น custodial wallet มีลักษณะเป็นอุปกรณ์ (device) โดย private key จะถูกเก็บไว้ในอุปกรณ์ในลักษณะ offline ทำให้มีความปลอดภัยสูง จากการโจรกรรมทางไซเบอร์',
        a_2: 'Paper wallet เป็น non-custodial wallet ผู้ใช้งานจะสร้าง wallet จากเว็บไซต์ แล้วจดหรือพิมพ์ private key เก็บไว้บนกระดาษแต่ก็มีความเสี่ยงที่หมึกจะจางหรือกระดาษสูญหายได้',
        a_3: 'desktop / mobile wallet เป็น non-custodial wallet เป็นการการติดตั้งโปรแกรม wallet ไว้ที่คอมพิวเตอร์หรือโทรศัพท์มือถือ โดยเก็บ private key ที่เข้ารหัสแล้วบนอุปกรณ์ดังกล่าว ความปลอดภัยจะขึ้นอยู่กับระดับการรักษาความปลอดภัยของอุปกรณ์นั้น ๆ',
        a_4: 'ข้อ B และ ข้อ C กล่าวถูกต้อง'
      },
      q_11: {
        q: 'ข้อใดกล่าวถูกต้องเกี่ยวกับการฝากสินทรัพย์ดิจิทัลของลูกค้าไว้ในกระเป๋าสินทรัพย์ดิจิทัลของผู้ประกอบธุรกิจ',
        a_1: 'มีการแบ่งแยกบัญชีทรัพย์สินลูกค้าออกจากทรัพย์สินของผู้ประกอบการ',
        a_2: 'ลูกค้าสามารถส่งคำสั่งโอนสินทรัพย์ดิจิทัลออกจากกระเป๋าของผู้ประกอบการได้ด้วยตนเอง',
        a_3: 'เก็บทรัพย์สินลูกค้าส่วนใหญ่ไว้กับผู้รับฝากสินทรัพย์ดิจิทัล',
        a_4: 'ถูกต้องทุกข้อ'
      },
      q_12: {
        q: 'ข้อใดคือประโยชน์ของกระเป๋าสินทรัพย์ดิจิทัล (Wallet)',
        a_1: 'ใช้เก็บรักษาธนบัตร',
        a_2: 'ใช้เก็บรักษาตราสารทางการเงิน',
        a_3: 'ใช้เก็บรักษาสินทรัพย์ดิจิทัล',
        a_4: 'ใช้เก็บรักษาทองคำแท่ง'
      },
      q_13: {
        q: 'ข้อใดต่อไปนี้ไม่ใช่กระเป๋าสินทรัพย์ดิจิทัล (Wallet) ที่ใช้เก็บรักษาสินทรัพย์ดิจิทัล',
        a_1: 'Hot Wallet',
        a_2: 'Cold Wallet / Storage',
        a_3: 'Hardware Wallet',
        a_4: 'บัญชีธนาคาร'
      },
      q_14: {
        q: 'นาย ก จัดเก็บสินทรัพย์ดิจิทัลด้วยตนเองโดยใช้ Hardware wallet (Trezor) หากนาย ก ทำ Trezor หาย นาย ก จะกู้ Private key ได้อย่างไร',
        a_1: 'แจ้งคณะกรรมการ ก.ล.ต.',
        a_2: 'ใช้ seed ที่สำรองไว้',
        a_3: 'ไม่สามารถกู้รหัสผ่านคืนได้'
      },
      q_15: {
        q: 'นักลงทุนสามารถใช้สิ่งใดในการตรวจสอบผลการทำธุรกรรม',
        a_1: 'Address',
        a_2: 'Transaction ID',
        a_3: 'ถูกทุกข้อ'
      },
      q_16: {
        q: 'ข้อใดคือประเภทของ Stablecoin',
        a_1: 'Fiat-Backed Stablecoin',
        a_2: 'Crypto-Backed Stablecoin',
        a_3: 'Algorithmic Stablecoin',
        a_4: 'ทุกข้อที่กล่าวมาคือประเภทของ Stablecoin '
      },
      q_17: {
        q: 'ธุรกรรมของสินทรัพย์ดิจิทัลสามารถตรวจสอบได้โดยการใช้ transaction ID หรือ Wallet address',
        a_1: 'จริง',
        a_2: 'เท็จ'
      },
      q_18: {
        q: 'คุณซื้อ Hardwere Wallet เพื่อเก็บ Bitcoin โดยตรงจากผู้ผลิต โดยได้ทำการตั้งค่าและเขียนคำกู้คืน 12 คำลงบนกระดาษ เมื่อคุณโอน Bitcoin ไปยัง Wallet Addressและกดยืนยัน ต่อมา Hardwere Wallet ดังกล่าวถูกทำลาย และได้ทำคำกู้คืนหาย คุณจะสามารถกู้คืน Bitcoin ได้อย่างไร',
        a_1: 'Bitcoin ไม่สามารถกู้คืนได้',
        a_2: 'สามารถกู้คืนได้โดยผู้ผลิต Bitcoin',
        a_3: 'สามารถกู้คืนได้โดยศูนย์ซื้อขายสินทรัพย์ดิจิทัล',
        a_4: 'สามารถกู้คืนได้โดยกลต'
      },
      q_19: {
        q: 'ข้อใดเป็นสิ่งที่ต้องพึงระวังสำหรับมือใหม่เกี่ยวกับเรื่องของ Wallet',
        a_1: 'Crypto Wallet ปลอม',
        a_2: 'ห้ามถ่ายรูป Seed Phrase เก็บไว้ใน PC, Smart Phone ฯลฯ',
        a_3: 'ตรวจสอบปลายทางในการโอนสินทรัพย์ดิจิทัลทุกครั้งอย่างระมัดระวัง',
        a_4: 'ถูกทุกข้อที่กล่าวมา'
      },
      q_20: {
        q: 'ข้อใดคือการเก็บรักษาสินทรัพย์ดิจิทัลที่ “ไม่ควร” ทำเป็นอย่างยิ่ง',
        a_1: 'เก็บสินทรัพย์ดิจิทัลไว้ใน Hardware Wallet ด้วยตนเอง',
        a_2: 'ฝากให้เพื่อนเก็บสินทรัพย์ดิจิทัล เพราะเพื่อนมีความรู้มากกว่าและเรารู้จักเพื่อนมานาน',
        a_3: 'เก็บสินทรัพย์ดิจิทัลไว้กับ Exchange',
        a_4: 'กระจายความเสี่ยงในการเก็บสินทรัพย์ดิจิทัลทั้งใน Hardware Wallet และ Exchange ตามวัตถุประสงค์ในการลงทุน'
      },
      q_21: {
        q: 'อะไรคือ cold storage?',
        a_1: 'กระเป๋าสินทรัพย์ดิจิทัลที่อาจอยู่ในรูปแบบของคอมพิวเตอร์ตั้งโต๊ะ',
        a_2: 'การเก็บเอกสารที่ไม่ได้อยู่บนเครื่องมืออิเล็กทรอนิกส์',
        a_3: 'Private Key ที่ไม่ได้ต่อกับอินเตอร์เน็ต',
        a_4: 'ถูกทุกข้อ'
      },
      q_22: {
        q: 'Custodial wallet คืออะไร',
        a_1: 'การให้บริการกระเป๋าเก็บสินทรัพย์ดิจิทัลที่มีการรับฝากสินทรัพย์ดิจิทัลของ ผู้ใช้งานหรือลูกค้าด้วย โดยผู้ให้บริการ custodial wallet จะเป็นผู้เก็บรักษา private key',
        a_2: 'กระเป๋าเก็บสินทรัพย์ดิจิทัลที่ผู้ให้บริการเป็นเพียงผู้พัฒนาโปรแกรมหรือ แอปพลิเคชัน โดยไม่ได้ทำหน้าที่เก็บรักษา private key ให้แก่ผู้ใช้งาน',
        a_3: 'ชื่อของบริษัทที่พัฒนา wallet',
        a_4: 'ถูกต้องทุกข้อ'
      },
      q_23: {
        q: 'ข้อใดไม่ถูกต้องเกี่ยวกับวิธีการจัดเก็บ Private Key และสินทรัพย์ดิจิทัลให้ปลอดภัย',
        a_1: 'จัดเก็บรหัส Private key ไว้บนระบบ cloud และ ทำสำเนาไว้ในคอมพิวเตอร์',
        a_2: 'จัดเก็บรหัส Private key ไว้ในรูปแบบ กระดาษ และจัดเก็บไว้ภายในตู้นิรภัย',
        a_3: 'เลือกใช้งาน Hardware Wallet และจัดเก็บไว้ภายในตู้นิรภัย',
        a_4: 'ไม่มีข้อใดถูก'
      },
      q_24: {
        q: 'Private Key สำคัญอย่างไร',
        a_1: 'ทำหน้าที่เหมือนรหัสลับ (password  เพื่อเข้าถึงสินทรัพย์ดิจิทัลใน Wallet)',
        a_2: 'ทำหน้าที่เหมือน Email address สามารถส่งให้ผู้อื่นได้',
        a_3: 'ถ้า Private Key หายสามารถสร้างใหม่ได้อย่างง่ายดาย',
        a_4: 'ถูกทุกข้อ'
      }
    },
    investment: {
      q_1: {
        q: 'ข้อใดถูกต้องเกี่ยวกับภาพรวมของตลาดคริปโทเคอร์เรนซี',
        a_1: 'ตลาดคริปโทเคอร์เรนซีมีความผันผวนมากกว่าตลาดหุ้น',
        a_2: 'ตลาดคริปโทเคอร์เรนซีมีความผันผวนน้อยกว่าตลาดหุ้น',
        a_3: 'ตลาดคริปโทเคอร์เรนซีไม่มีความผันผวน'
      },
      q_2: {
        q: 'ข้อใดเป็นปัจจัยที่มีผลต่อราคาการซื้อขายคริปโทเคอร์เรนซี',
        a_1: 'ข่าวสารที่เกี่ยวข้องกับคริปโทเคอร์เรนซีดังกล่าว',
        a_2: 'สถานการณ์ที่ส่งผลต่อสภาวะตลาดโลก',
        a_3: 'ถูกทุกข้อ'
      },
      q_3: {
        q: 'ข้อใดไม่ใช่ปัจจัยในการประเมินมูลค่าพื้นฐานของสินทรัพย์ดิจิทัล',
        a_1: 'ปริมาณของเหรียญว่ามีอยู่อย่างจำกัดหรือสามารถสร้างเพิ่มขึ้นได้',
        a_2: 'สัญญาอัจฉริยะ (Smart Contract) ที่ใช้กับสินทรัพย์ดิจิทัลควรได้รับการตรวจสอบโดยผู้ตรวจสอบที่น่าเชื่อถือ',
        a_3: 'รูปแบบในการนำสินทรัพย์ดิจิทัลไปใช้ประโยชน์หรือสิทธิต่างๆ เช่น เพื่อระบบการเงินแบบไม่รวมศูนย์ เพื่อสนับสนุนอำนาจในการโหวต ผลประโยชน์ตอบแทนที่ได้รับจากการถือสินทรัพย์ดิจิทัล เป็นต้น',
        a_4: 'ความผันผวนของราคา'
      },
      q_4: {
        q: 'ข้อใดต่อไปนี้เป็นการสร้างพอร์ตการลงทุนที่สัมพันธ์กับความเสี่ยงที่ยอมรับได้',
        a_1: 'รับความสูญเสียได้ 10% ของเงินลงทุนทั้งหมด : ลงทุนในคริปโทเคอร์เรนซี 10%',
        a_2: 'รับความสูญเสียได้ 50% ของเงินลงทุนทั้งหมด : ลงทุนในคริปโทเคอร์เรนซี 50%',
        a_3: 'รับความสูญเสียได้ 100% ของเงินลงทุนทั้งหมด : ลงทุนในคริปโทเคอร์เรนซี 100%',
        a_4: 'ถูกทุกข้อ'
      },
      q_5: {
        q: 'ข้อใดคือลักษณะของตลาดสินทรัพย์ดิจิทัล',
        a_1: 'เป็นตลาดที่มีความผันผวนสูง',
        a_2: 'ยังไม่ถูกกฎหมายในบางประเทศ',
        a_3: 'เป็นตลาดที่สามารถซื้อขายได้ 24 ชั่วโมงต่อวัน',
        a_4: 'ถูกทุกข้อ'
      },
      q_6: {
        q: 'ข้อใดกล่าวถูกต้องเกี่ยวกับสภาวะตลาด คริปโทเคอร์เรนซีที่มีผลกระทบต่อการลงทุน',
        a_1: 'แนวโน้มของตลาดจะผลักดันให้ทุกอุตสาหกรรมต้องเข้ามาอยู่ในรูปแบบดิจิทัล (Digitalization)',
        a_2: 'แม้ว่าตลาดคริปโทเคอร์เรนซีจะมีความผันผวนสูงเป็นปกติ แต่จำนวนของผู้ลงทุนหน้าใหม่ๆ ก็เพิ่มมากขึ้นเรื่อยๆ ในช่วงหลายปีที่ผ่านมา',
        a_3: 'โซเชียลมีเดียถือเป็นเครื่องมือวิเคราะห์สภาวะตลาดที่สำคัญอย่างหนึ่งสำหรับนักลงทุนคริปโทเคอร์เรนซีมือใหม่',
        a_4: 'ถูกทุกข้อ'
      },
      q_7: {
        q: 'ข้อใดกล่าวไม่ถูกต้องเกี่ยวกับความผันผวน ของราคาคริปโทเคอร์เรนซี',
        a_1: 'ตลาดคริปโทเคอร์เรนซีมีความผันผวนน้อยกว่าตลาดหุ้น',
        a_2: 'ข่าวสารและทวิตเตอร์คนดังมีผลต่อการขึ้นหรือลงของราคาคริปโทเคอร์เรนซี',
        a_3: 'เสถียรภาพทางเศรษฐกิจมีผลต่อความผันผวนของราคาคริปโทเคอร์เรนซี',
        a_4: 'ความผันผวนของราคาส่งผลกระทบต่อเนื่องไปยังความน่าเชื่อถือของเงินสกุลดิจิทัล หากมีความน่าเชื่อถือในระดับต่ำ ความเสี่ยงก็จะสูง และส่งผลต่อการตัดสินใจลงทุนในคริปโทเคอร์เรนซี'
      },
      q_8: {
        q: 'ข้อใดไม่ใช่สิ่งที่ควรปฏิบัติในการกระจายความเสี่ยงและวางกลยุทธ์ในการลงทุน',
        a_1: 'ลงทุนในความเสี่ยงที่เหมาะสมกับความเสี่ยงที่ยอมรับได้',
        a_2: 'หมั่นติดตามบัญชีซื้อขายคริปโทเคอร์เรนซีอยู่เสมอ',
        a_3: 'ทำการศึกษาหาข้อมูลให้ครบถ้วนก่อนตัดสินใจลงทุน เพื่อให้เข้าใจลักษณะความเสี่ยงและ ผลตอบแทนของสินทรัพย์แต่ละประเภท',
        a_4: 'ควรลงทุนโดยให้น้ำหนักการลงทุนในสินทรัพย์ดิจิทัลเพียงอย่างเดียว'
      },
      q_9: {
        q: 'ข้อใดกล่าวไม่ถูกต้อง',
        a_1: 'ระมัดระวังและตรวจสอบความถูกต้องในการโอนสินทรัพย์ดิจิทัลทุกครั้งเพื่อป้องกันการสูญหาย',
        a_2: 'คริปโทเคอร์เรนซีมีมูลค่าค่อนข้างคงที่ ดังนั้น นักลงทุนที่รับความเสี่ยงได้ต่ำควรมีสัดส่วนการลงทุนในคริบโตเคอร์เรนซีมากกว่าสินทรัพย์ประเภทอื่น',
        a_3: 'ราคาและปริมาณการซื้อขายของคริปโทเคอร์เรนซี ขึ้นกับปัจจัยต่างๆ เช่น Demand และ Supply ในขณะนั้น ข่าวสารจากผู้พัฒนาplatform หรือ จาก Influencer ผ่าน Social Media ต่างๆ',
        a_4: 'ผู้ลงทุนควรศึกษาหาข้อมูล มีการกระจายความเสี่ยงและมีกลยุทธ์การลงทุนให้เหมาะสมกับผลประเมินความเสี่ยงของตนเอง (Suitability Test)'
      },
      q_10: {
        q: 'ข้อใดถูกต้องที่สุดเกี่ยวกับแนวทางการคำนวณมูลค่าพื้นฐานของคริปโทเคอร์เรนซี',
        a_1: 'ประเมินมูลค่าตลาดของสกุลเงินคริปโทเคอร์เรนซีกับมูลค่าของทองคำ',
        a_2: 'ประเมินมูลค่าด้วยวิธีเดียวกับสกุลเงินทั่วไปโดยประเมินจากปริมาณและรอบหมุนของเงินในระบบ',
        a_3: 'ประเมินมูลค่าของคริปโทเคอร์เรนซีเป็นเสมือนสินค้า และผลิตภัณฑ์ โดยคำนวณจากต้นทุนการผลิต',
        a_4: 'การประเมินมูลค่าพื้นฐานของคริปโทเคอร์เรนซีส่วนใหญ่ยังเป็นเรื่องใหม่ และยังไม่มีทฤษฎีที่แน่นอนรองรับ'
      },
      q_11: {
        q: 'ข้อใดอธิบายตลาดซื้อขายสินทรัพย์ดิจิทัลได้อย่างถูกต้อง',
        a_1: 'เปิดให้บริการซื้อขาย 24 ชั่วโมง',
        a_2: 'สินทรัพย์ที่ซื้อขายจะอยู่ในรูปของคริปโทเคอร์เรนซีและโทเคนดิจิทัล',
        a_3: 'ความเสี่ยงและความผันผวนของราคาของแต่ละสกุลเงินดิจิทัล / โทเคนดิจิทัลอาจแตกต่างกันไปตามเศรษฐศาสตร์พื้นฐาน',
        a_4: 'ถูกทุกข้อ'
      },
      q_12: {
        q: 'ข้อใดไม่ใช่ข้อควรปฏิบัติก่อนตัดสินใจลงทุนในคริปโทเคอร์เรนซี',
        a_1: 'ลงทุนตามคำแนะนำของผู้เชี่ยวชาญ',
        a_2: 'ศึกษาข้อมูลของเหรียญก่อนการลงทุนอย่างละเอียด',
        a_3: 'ศึกษา white paper ของเหรียญก่อนตัดสินใจลงทุน',
        a_4: 'ประเมินความเสี่ยงของตัวเองก่อนการลงทุน'
      },
      q_13: {
        q: 'ข้อใดกล่าวถูกต้องที่สุดเกี่ยวกับลักษณะความเสี่ยงของการลงทุนในสินทรัพย์ดิจิทัล',
        a_1: 'มีความเสี่ยงต่ำ และให้ผลตอบแทนต่ำ',
        a_2: 'ราคาซื้อขายมีความผันผวนสูง สามารถสูญเสียเงินลงทุนทั้งหมดได้ในเวลาอันรวดเร็ว',
        a_3: 'มีความเสี่ยงปานกลาง และให้ผลตอบแทนสูง',
        a_4: 'ความเสี่ยงและความผันผวนของแต่ละสินทรัพย์พิจิทัลจะแตกต่างกันไปตามปัจจัยพื้นฐานทางธุรกิจและเศรษฐศาตร์ที่สินทรัพย์ดิจิทัลมีการอ้างอิง'
      },
      q_14: {
        q: 'ข้อใดกล่าวไม่ถูกต้อง ในการประเมินความเสี่ยงหากพบ เหรียญ หรือ โทเคน ราคาสูงขึ้นอย่างผิดปกติ ก่อนที่จะเริ่มทำการซื้อ-ขาย',
        a_1: 'เทียบราคาของ เหรียญ หรือ โทเคน นั้นๆ กับผู้ให้บริการรายอื่นๆ ก่อนทำการส่งคำสั่งซื้อ-ขาย',
        a_2: 'ติดต่อผู้ให้บริการเพื่อตรวจสอบว่า เหรียญ หรือ โทเคน ราคาสูงขึ้นอย่างผิดปกติ จริงหรือไม่',
        a_3: 'หาโอกาสทำกำไรในทันที',
        a_4: 'ยกเลิกคำสั่งซื้อ - ขาย ที่ตั้งไว้ทันทีเพื่อป้องกันการ Match Order ที่ไม่พึงประสงค์'
      },
      q_15: {
        q: 'คริปโทเคอเรนซีจัดอยู่ในกลุ่มสินทรัพย์ที่มีความเสี่ยงระดับใด',
        a_1: 'เสี่ยงสูง',
        a_2: 'เสี่ยงกลาง',
        a_3: 'เสี่ยงต่ำ',
        a_4: 'ไม่มีความเสี่ยงใดๆ'
      },
      q_16: {
        q: 'ข้อใดต่อไปนี้ถูกต้องเกี่ยวกับ การเตรียมตัวในการเริ่ม ซื้อ-ขาย “คริปโทเคอเรนซี”',
        a_1: 'ตรวจสอบความเสี่ยงที่ยอมรับได้ของตนเองในราคาที่ผันผวนสูงของคริปโทเคอเรนซี',
        a_2: 'เลือกใช้บริการผู้ให้บริการแพลทฟอร์มที่ได้รับการรับรองจากหน่วยงานของรัฐฯ',
        a_3: 'ศึกษาข้อมูลของ คริปโทเคอเรนซี แต่ละสกุลอย่างละเอียดก่อนทำการซื้อ - ขาย',
        a_4: 'ถูกทั้ง 3 ข้อ'
      },
      q_17: {
        q: 'ข้อใดคือรูปแบบการซื้อขายที่นักลงทุนที่ขาดประสบการณ์ควรหลีกเลี่ยง',
        a_1: 'Margin trading',
        a_2: 'Spot trading',
        a_3: 'Holding',
        a_4: 'ถูกทุกข้อ'
      },
      q_18: {
        q: 'ข้อใดที่ “ไม่ควร” ทำเป็นอย่างยิ่งในการลงทุนในสินทรัพย์ดิจิทัล',
        a_1: 'ศึกษาหาข้อมูลเกี่ยวกับสินทรัพย์ดิจิทัลให้ครบถ้วนและติดตามข่าวสารอยู่เสมอ',
        a_2: 'กระจายความเสี่ยงอย่างเหมาะสมและแบ่งน้ำหนักการลงทุนในสินทรัพย์ดิจิทัลตามความเสี่ยงที่เรายอมรับได้เท่านั้น',
        a_3: 'All In ในเหรียญที่มีอนาคตและคิดเอาเองว่าจะเติบโตมาก ๆ เพราะโอกาสสร้างตัวไม่ได้มีมาบ่อย ๆ',
        a_4: 'ถูกทุกข้อที่กล่าวมา'
      },
      q_19: {
        q: 'ปัจจัยใดอาจจะส่งผลให้ราคาสินทรัพย์ดิจิทัลปรับตัวลดลงได้',
        a_1: 'ความนิยมและความต้องการสินทรัพย์ดิจิทัลที่เพิ่มสูงในอนาคต (Demand เพิ่มมากขึ้น)',
        a_2: 'นักลงทุนรายใหญ่และกองทุนขนาดใหญ่ ต้องการซื้อสินทรัพย์ดิจิทัลเพราะอยากกระจายพอร์ตการลงทุนให้หลากหลาย (Asset Allocation)',
        a_3: 'ธนาคารกลางสหรัฐ ฯ (FED)  ทำ Quantitative Tightening (QT) คือการดึงสภาพคล่องออกจากระบบการเงิน ทำให้สินทรัพย์เสี่ยงทั่วโลกปรับตัวลง รวมถึงสินทรัพย์ดิจิทัล',
        a_4: 'ไม่มีข้อใดที่ถูกต้อง'
      },
      q_20: {
        q: 'ข้อใดไม่ใช่ข้อควรปฏิบัติก่อนตัดสินใจลงทุนในคริปโทเคอร์เรนซี',
        a_1: 'ลงทุนตามคำแนะนำของผู้เชี่ยวชาญ',
        a_2: 'ศึกษาข้อมูลของเหรียญก่อนการลงทุนอย่างละเอียด',
        a_3: 'ศึกษา white paper ของเหรียญก่อนตัดสินใจลงทุน',
        a_4: 'ประเมินความเสี่ยงของตัวเองก่อนการลงทุน'
      },
      q_21: {
        q: 'มูลค่าตลาดของคริปโตเคอร์เรนซี (Market Capitalization) คำนวนได้อย่างไร',
        a_1: 'ราคาตลาด * ปริมาณฝากถอน',
        a_2: 'ราคาตลาด * ปริมาณของสินทรัพย์',
        a_3: 'ราคาตลาด * ความต้องการซื้อขาย',
        a_4: 'ถูกต้องทุกข้อ'
      }
    }
  },
  knowledge_test_correct_answer: {
    correct_answer: 'คำตอบที่ถูกต้อง'
  },
  summary_of_suit_test: {
    title: 'ผลทดสอบความเสี่ยงในการลงทุน',
    user_risk_point:
      'ระดับคะแนนความเสี่ยงของคุณคือ <b>{{suitabilityTestPoint}}</b> จาก <b>50</b>',
    user_risk_level: {
      low: `แสดงว่าเป็นนักลงทุนประเภท<b>ความเสี่ยงต่ำ</b> กล่าวคือ ท่านต้องการผลตอบแทนจำนวนเล็กน้อยที่แน่นอน มากกว่าผลตอบแทนจำนวนมากที่ไม่แน่นอน<br><br>
      <b>เหมาะที่จะลงทุนโดยการฝากเงินธนาคาร หรือตราสารหนี้ความเสี่ยงต่ำ</b><br><br>
        <i>“การลงทุนในสินทรัพย์ดิจิทัลมีความผันผวนของตลาดและราคาภายในระยะเวลาอันรวดเร็ว ผู้ลงทุนควรศึกษาและทำความเข้าใจพื้นฐานการลงทุนด้านสินทรัพย์ดิจิทัลก่อนการลงทุน และควรติดต่อข่าวสารเกี่ยวกับสินทรัพย์ดิจิทัลอยู่เสมอระหว่างการลงทุน”</i>`,
      medium: `แสดงว่าเป็นนักลงทุนประเภท<b>ความเสี่ยงปานกลาง</b> กล่าวคือ ท่านสามารถรับความเสี่ยงได้บ้างเพื่อแลกกับผลตอบแทนที่เพิ่มขึ้น แต่ยังคงมุ่งเน้นปกป้องเงินลงทุนและหวังรายได้อย่างสม่ำเสมอจากการลงทุน<br><br>
      <b>เหมาะที่จะลงทุนโดยการซื้อตราสารหนี้หรือตราสารทุนความเสี่ยงต่ำ</b><br><br>
        <i>“การลงทุนในสินทรัพย์ดิจิทัลมีความผันผวนของตลาดและราคาภายในระยะเวลาอันรวดเร็ว ผู้ลงทุนควรศึกษาและทำความเข้าใจพื้นฐานการลงทุนด้านสินทรัพย์ดิจิทัลก่อนการลงทุน และควรติดต่อข่าวสารเกี่ยวกับสินทรัพย์ดิจิทัลอยู่เสมอระหว่างการลงทุน”</i>`,
      hight: `แสดงว่าเป็นนักลงทุนประเภท<b>ความเสี่ยงสูง</b> กล่าวคือ ท่านสามารถรับความเสี่ยงสูงจากการผันผวนของตลาดได้ โดยสามารถรับผลขาดทุนจำนวนมากเพื่อแลกกับโอกาสในการได้รับผลตอบแทนสูงหรือผลตอบแทนระยะยาว<br><br>
      <b>เหมาะที่จะลงทุนโดยการซื้อตราสารทุน ตราสารอนุพันธ์ หรือสินทรัพย์ดิจิทัลที่มีเสถียรภาพด้านราคา</b>`,
      very_hight: `แสดงว่าเป็นนักลงทุนประเภท<b>ความเสี่ยงสูงมาก</b>กล่าวคือ ท่านสามารถรับความเสี่ยงสูงมากจากการผันผวนของตลาดได้ โดยสามารถรับผลขาดทุนทั้งหมดเพื่อแลกกับโอกาสได้รับผลตอบแทนเป็นทวีคูณ<br><br>
      <b>เหมาะที่จะลงทุนโดยการซื้อสินทรัพย์ดิจิทัล</b>`
    },
    backward_btn: 'กลับหน้าหลัก',
    invite_knowledge_test: {
      title: 'ท่านต้องการทำแบบทดสอบความเสี่ยงในการลงทุนต่อเลยหรือไม่?',
      describe:
        'เมื่อท่านได้รับการยืนยันตัวตน , ทำแบบทดสอบความเสี่ยงในการลงทุน และ ทำแบบทดสอบความรู้ เรียบร้อยแล้ว ท่านจะสามารถเทรดได้',
      text_btn: 'ทำแบบทดสอบความรู้'
    },
    rules_detail: `การลงทุนสินทรัพย์ดิจิทัลในระบบ decentralized เป็นการซื้อขายแลกเปลี่ยนสินทรัพย์ดิจิทัลโดยลูกค้าเป็นผู้เก็บรักษาสินทรัพย์ดิจิทัลไว้ด้วยตนเอง ลูกค้าจึงควรศึกษาและทำความเข้าใจวิธีการเก็บรักษาสินทรัพย์ดิจิทัลไว้ด้วยตนเองก่อนการลงทุนทุก
      ครั้ง นอกจากนี้ การโอนสินทรัพย์ดิจิทัลระหว่างกันเป็นการโอนกันตามความเป็นจริง จึงต้องใช้ระยะเวลาในการยืนยันธุรกรรม ซึ่งอาจทำให้อัตราแลกเปลี่ยนที่ลูกค้าได้รับเปลี่ยนแปลง ลูกค้าจึงควรศึกษาการกำหนดอัตราผันผวนและระยะเวลาการยืนยันธุรกรรมสินทรัพย์ดิจิทัลแต่ละประเภทก่อนการตัดสินใจลงทุนทุกครั้ง`
  },
  summary_of_knowledge_test: {
    title: 'ผลทดสอบความรู้',
    user_risk_point:
      'ระดับคะแนนความรู้ของคุณคือ <b>{{knowledgeTestPoint}}</b> จาก <b>10</b>',
    describe:
      'ท่านสามารถศึกษาหาความรู้เพิ่มเติมได้จากไฟล์ข้อมูลคำแนะนำการลงทุนต่อไปนี้',
    article_1: 'โลกแห่งสินทรัพย์ดิจิทัล (World of digital asset)',
    article_2: 'ระบบเศรษฐกิจสินทรัพย์ดิจิทัล (Ecosystem of digital asset)',
    article_3:
      'พื้นฐานการลงทุนในสินทรัพย์ดิจิทัล (Basic of digital asset investment)',
    article_4: 'รูปแบบการให้บริการ (Service Form)',
    article_5: 'การแทรกแซงราคา (Market Manipulations)',
    article_6: ' ภาคผนวก (Appendix)',
    invite_suite_test: {
      title: 'ท่านต้องการทำแบบทดสอบความเสี่ยงต่อเลยหรือไม่?',
      describe:
        'เมื่อท่านได้รับการยืนยันตัวตน, ทำแบบทดสอบความเสี่ยงในการลงทุน และ ทำแบบทดสอบความรู้ เรียบร้อยแล้ว ท่านจะสามารถเทรดได้',
      text_btn: 'ทำแบบทดสอบความเสี่ยงในการลงทุน'
    }
  },
  fees: {
    title: 'โครงสร้างค่าธรรมเนียม',
    description:
      'ค่าธรรมเนียมรวมในการซื้อสินทรัพย์ดิจิทัลบนแพลตฟอร์ม KULAP+ คำนวณจากผลรวมของค่าธรรมเนียม Payment Gateway และค่าธรรมเนียมแพลตฟอร์ม KULAP+',
    formula_title: 'สูตรการคำนวณค่าธรรมเนียม',
    gateway_fee_label:
      'ค่าธรรมเนียม Payment Gateway: คงที่ 15 บาทต่อรายการ (ค่าบริการ PromptPay)',
    kulap_fee_label:
      'ค่าธรรมเนียมแพลตฟอร์ม KULAP+: 0.2% ของจำนวนเงินที่ซื้อ (ค่าบริการแพลตฟอร์ม KULAP+)',
    total_fee_label: 'ค่าธรรมเนียมรวม = 15 บาท + (จำนวนเงินที่ซื้อ × 0.2%)',
    table_title: 'ตัวอย่างค่าธรรมเนียม',
    table_header_purchase_amount: 'จำนวนเงินที่ซื้อ (บาท)',
    table_header_gateway_fee: 'ค่าธรรมเนียม Gateway (บาท)',
    table_header_kulap_fee: 'KULAP+ 0.2% (บาท)',
    table_header_total_fee: 'ค่าธรรมเนียมรวม (บาท)',
    note_gas_fee:
      'ค่าธรรมเนียมข้างต้นยังไม่รวมค่า Network Fee (Gas Fee) จากเครือข่าย Blockchain ซึ่งจะแสดงแยกต่างหากในขั้นตอนยืนยันคำสั่งซื้อ',
    note_fee_change:
      'อัตราค่าธรรมเนียมอาจมีการเปลี่ยนแปลง โดยบริษัทจะแจ้งให้ผู้ใช้งานทราบล่วงหน้าก่อนการเปลี่ยนแปลงมีผลบังคับใช้',
    note_payment_channel: 'ช่องทางการชำระเงิน: พร้อมเพย์ (PromptPay)'
  },
  footer: {
    products: 'ผลิตภัณฑ์',
    support: 'ช่วยเหลือ',
    social_media: 'โซเชียลมีเดีย',
    buy_crypto: 'ซื้อคริปโต',
    sell_crypto: 'ขายคริปโต',
    fees: 'ค่าธรรมเนียม',
    terms: 'ข้อกำหนดการใช้บริการ',
    sourced_exchange: 'รายชื่อศูนย์ซื้อขายสินทรัพย์ดิจิทัลที่เชื่อมต่อ',
    quality_of_service: 'ข้อมูลคุณภาพการให้บริการ',
    annual_financial_statements: 'งบการเงินประจำปี'
  },
  acknowledge_risk: {
    template: acknowledgeTemplateTh
  },
  terms_and_conditions: {
    template: termsAndConditionsTemplateTh
  }
}
